import { useEffect, useRef } from 'react';

/**
 * Call callback when user clicks outside any of the given refs' elements.
 * @param {React.RefObject|React.RefObject[]} refs - Single ref or array of refs
 * @param {function} callback - (event) => void
 */
export function useClickOutside(refs, callback) {
  const refsRef = useRef(refs);
  const callbackRef = useRef(callback);
  refsRef.current = refs;
  callbackRef.current = callback;

  useEffect(() => {
    const handleClickOutside = (e) => {
      const refList = Array.isArray(refsRef.current) ? refsRef.current : [refsRef.current];
      const isOutside = refList.every(
        (ref) => ref?.current == null || !ref.current.contains(e.target)
      );
      if (isOutside) callbackRef.current(e);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
}
